import { t } from "@/i18n-js/instance";
import { ExecutePreviewCard } from "./ExecutePreviewCard";

export interface MemberExecutePreviewProps {
  email?: string;
  name?: string;
}

export const MemberExecutePreview = ({
  name,
  email,
}: MemberExecutePreviewProps) => (
  <ExecutePreviewCard
    title={t("help_widget.copilot.execute_preview.member_title")}
    attributes={[
      {
        label: t("help_widget.copilot.execute_preview.name"),
        value: name,
      },
      {
        label: t("help_widget.copilot.execute_preview.email"),
        value: email,
      },
    ]}
  />
);
